import { DateTimeV2 } from '../../../value-object/DateTimeV2'

export type VersionReportVersionEntity = {
  uuid: string
  lockVersion: number
  snapshotUuid: string
  templateUuid: string
  templateName: string
  name: string
  pages: VersionReportVersionPageEntity[]
  createdAt: DateTimeV2
  createdBy: {
    uuid: string
    name: string
  }
  updatedAt: DateTimeV2
  updatedBy: {
    uuid: string
    name: string
  }
  takenAt: DateTimeV2
  discussionThreadCountByTemplatePage?: Record<string, number>
}

export type VersionReportVersionPageEntity = {
  uuid: string
  lockVersion: number
  templatePageUuid: string
  pageTitle: string
  leadSentence: string | undefined
  pageNumber: number
  pageType: VersionReportPageType
  config: VersionReportPageConfig
  rows: VersionReportVersionPageRowEntity[]
}

export type VersionReportVersionPageRowEntity = {
  uuid: string
  lockVersion: number
  targetUuid: string
  displayOrder: number
  status: VersionReportStatus
  comment: string
}

export const sortTargetUuidsByDisplayOrder = (
  rows: VersionReportVersionPageRowEntity[]
): string[] =>
  rows
    .slice()
    .sort((a, b) => a.displayOrder - b.displayOrder)
    .map(row => row.targetUuid)

export type VersionReportStatus = 'SUNNY' | 'CLOUDY' | 'RAINY'

export type VersionReportPageType =
  | 'PROGRESS_OVERVIEW'
  | 'PROGRESS_REPORT_BY_PROCESS'
  | 'PROGRESS_REPORT_BY_TEAM'
  | 'PROGRESS_REPORT_BY_TICKET_LIST'

export type VersionReportPageConfig =
  | ProgressOverviewPageConfig
  | ProgressReportByProcessPageConfig
  | ProgressReportByTeamPageConfig
  | ProgressReportByTicketListPageConfig
export type ProgressOverviewPageConfig = {
  type: 'PROGRESS_OVERVIEW'
  tableRows: string[]
}
export type ProgressReportByProcessPageConfig = {
  type: 'PROGRESS_REPORT_BY_PROCESS'
  tableRows: string[]
}
/** チケット管理表別進捗状況。tableRows は行にするチケット管理表（スナップショット上のノードuuid）。 */
export type ProgressReportByTicketListPageConfig = {
  type: 'PROGRESS_REPORT_BY_TICKET_LIST'
  tableRows: string[]
}
/**
 * 進捗報告の集計範囲を、工程（配下の WBS 項目）とチケット管理表（所属するチケット）のどちらで取るか。両者は排他。
 * チーム別集計の基準と、工程別・チケット管理表別進捗状況の表の行の両方に使う。
 */
export type ProgressReportScopeType = 'PROCESS' | 'TICKET_LIST'

export type ProgressReportByTeamPageConfig = {
  type: 'PROGRESS_REPORT_BY_TEAM'
  scopeType: ProgressReportScopeType
  /**
   * 集計基準となるノードの projectPlanUuid。工程・チケット管理表のどちらを選んでも
   * 同じ「スナップショット上のノードuuid」という通貨で扱えるため、scopeTypeでは
   * フィールドを分けず1つに統一する（解決方法がscopeTypeで変わるだけ）。
   */
  rootUuid: string | undefined
  tableRows: string[]
}
